import { atom, map, WritableAtom, type MapStore } from 'nanostores';

import invariant from 'tiny-invariant';
import { AuthSchemeConfig, ConnectionCreate, ConnectionSummary } from '~/services/versori-api/types';
import { versoriApiFetchClient } from '~/services/versori-api/versoriApi';

export type ConnectionType = {
  name: string;
  connectionType: AuthSchemeConfig;
};

export class ConnectionStore {
  currentConnection: WritableAtom<ConnectionSummary | null> = atom<ConnectionSummary | null>(null);

  availableConnections: MapStore<Record<string, ConnectionSummary>> = map({});

  organisationConnections: MapStore<Record<string, ConnectionSummary>> = map({});

  organisationSystemConnections: MapStore<Record<string, ConnectionSummary[]>> = map({});

  selectedUserConnections: MapStore<Record<string, ConnectionSummary[]>> = map({});

  setAvailableConnections = (connections: ConnectionSummary[]) => {
    this.availableConnections.set(connections.reduce((acc, conn) => ({ ...acc, [conn.id]: conn }), {}));
  };

  setCurrentConnection = (connections: ConnectionSummary[]) => {
    const currentConnection = connections.reduce((acc, conn) => ({ ...acc, [conn.id]: conn }), {}) as ConnectionSummary;
    this.currentConnection.set(currentConnection);
  };

  setOrganisationConnections = (connections: ConnectionSummary[]) => {
    this.organisationConnections.set(connections.reduce((acc, conn) => ({ ...acc, [conn.id]: conn }), {}));
  };

  setOrganisationSystemConnections = (systemName: string, connections: ConnectionSummary[]) => {
    this.organisationSystemConnections.setKey(systemName, connections);
  };

  setSelectedUserConnections = (userId: string, connections: ConnectionSummary[]) => {
    this.selectedUserConnections.setKey(userId, connections);
  };

  onCreateConnection = async (organisationId: string, connection: ConnectionCreate, connectionTemplateId: string) => {
    try {
      const data = await versoriApiFetchClient.POST('/o/{organisation_id}/connections', {
        params: {
          path: {
            organisation_id: organisationId,
          },
        },
        body: { connectionTemplateId, connection },
      });
      invariant(data.data, 'No data returned from createConnection');
      return data.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
}
